import { Pipe, PipeTransform } from '@angular/core';
import { DropdownOptionData } from '../../column-filter/column-filter-dropdown-option-data';

@Pipe({ name: 'CropDropDownData' })
export class CropDropDownDataPipe implements PipeTransform {
    transform(crops: string[]): DropdownOptionData[] {
        if (!crops) {
            return [];
        }
        return crops.map((crop) => {
            return {
                id: crop,
                text: crop
            };
        });
    }
}
